import React, { useEffect } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { CONFIG } from "../config";

const Auth0ProviderWithHistory = ({ children }) => {
  // Setup React Native WebView authentication
  useEffect(() => {
    // Check if running inside a React Native WebView
    if (window.isInApp) {
      console.log(
        "Detected app environment: setting up authentication handlers"
      );

      // Listen for authentication events from the app
      window.onAppAuthenticated = function (credentials) {
        console.log("Authenticated via app, tokens received");

        // Use the tokens to authenticate with your backend
        fetch(`${CONFIG.API_URL}/user/auth/validate-token`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.idToken}`,
          },
          body: JSON.stringify({
            accessToken: credentials.accessToken,
            idToken: credentials.idToken,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Backend authentication successful", data);

            // Store tokens for API calls
            localStorage.setItem("access_token", credentials.accessToken);
            localStorage.setItem("id_token", credentials.idToken);

            // Reload the app to apply the authentication state
            window.location.reload();
          })
          .catch((error) => {
            console.error("Backend authentication failed", error);
          });
      };
    }
  }, []);

  return (
    <Auth0Provider
      domain={CONFIG.Auth0Domain}
      clientId={CONFIG.Auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: CONFIG.Auth0Audience,
      }}
      audience={CONFIG.Auth0Audience}
      cacheLocation="localstorage" // <-- add this config
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
